import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import styled from "styled-components";
import { Trans } from "../utils/i18n";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const ValidateAddress = React.memo(function ({ product, form, values: { street, zip, city} }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { products } = useFormState();

        const [places, setPlaces] = useState([]);

        useEffect(() => {
            const service = new window.google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: `${street} ${zip} ${city}` }, (predictions, status) => {
                setPlaces(predictions);
            });

        }, [street, zip, city]);

        if (!places) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        return (
            <div>
                <Grid container spacing={3}>
                    {
                        places
                            .map((item) =>
                                <Grid item xs={12} sm={3} key={item.id}>
                                    <Field
                                        name={'places'}
                                        type={'radio'}
                                        value={String(item.id)}
                                        //placeholder={field.placeholder}
                                        component={RadioButton}
                                        validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                        field={{
                                            titel: item.description,
                                            image: item.image,
                                        }}
                                    />
                                </Grid>,
                            )
                    }
                </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default ValidateAddress;
